import { MenuItemType } from '../common';

export const ImageKitFolders = {
    Places: 'places',
    CustomerAvatar: 'customer-avatars',
    UserAvatar: 'user-avatars',
    MenuItem: 'menu-items',
    Categories: 'categories',
    ServingContainers: 'serving-containers',
};

export const ImageKitMenuItemFolders: Record<MenuItemType, string> = {
    StandardDrink: `${ImageKitFolders.MenuItem}/standard-drinks`,
    CustomDrink: `${ImageKitFolders.MenuItem}/custom-drinks`,
    Product: `${ImageKitFolders.MenuItem}/products`,
};

export const ImageKitCustomMetadataKeys = {
    Type: 'type',
    UserType: 'userType',
    DrinkType: 'drinkType',
    Id: 'id',
    Env: 'env',
};

export const ImageKitTypes = {
    Avatar: 'avatar',
    Category: 'category',
    MenuItem: 'menuItem',
    Place: 'place',
    Product: 'product',
    ServingContainer: 'servingContainer',
};

export const ImageKitUserTypes = {
    User: 'user',
    Customer: 'customer',
};

export const ImageKitNamedTransforms = {
    Common: {
        avatar: 'n-avatar',
    },
    Web: {
        cover: 'n-web_cover',
        coverLq: 'n-web_cover_lq',
        square: 'n-web_square',
        squareLq: 'n-web_square_lq',
    },
    mobile: {
        cover: 'n-mobile_cover',
        coverLq: 'n-mobile_cover_lq',
        square: 'n-mobile_square',
        squareLq: 'n-mobile_square_lq',
    },
};

export const WEB_AVATAR_SIZE = 300;
export const WEB_SQUARE_SIZE = 300;
export const MOBILE_AVATAR_SIZE = 300;
